import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Row } from "react-bootstrap";
import { Trans } from "react-i18next";

function RiskFactorDetails({ riskFactor, onEdit, onDelete }) {
    return (
        <>
            <Row>
                <Col className="text-muted"><Trans>riskFactorDetailsName</Trans></Col>
                <Col>{riskFactor.name}</Col>
            </Row>

            <Row>
                <Col className="text-muted"><Trans>riskFactorDetailsCodeName</Trans></Col>
                <Col>{riskFactor.code_name}</Col>
            </Row>

            <Row>
                <Col className="text-muted"><Trans>riskFactorDetailsProtProperties</Trans></Col>
                <Col>{riskFactor.prot_properties_str}</Col>
            </Row>

            {onEdit && onDelete && (
                <Row>
                    <Col>
                        <div className="d-flex justify-content-center">
                            <Button variant="link" onClick={onEdit}><FontAwesomeIcon icon={faEdit} /> <Trans>Edit</Trans></Button>
                            <Button variant="link" className="text-danger" onClick={() => onDelete(riskFactor.id)}><FontAwesomeIcon icon={faTrash} /> <Trans>Delete</Trans></Button>
                        </div>
                    </Col>
                </Row>
            )}
        </>
    );
}

export default RiskFactorDetails;
